import script from "./MarcaVehiculoTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./MarcaVehiculoTable.vue?vue&type=script&setup=true&lang=ts"

import "./MarcaVehiculoTable.vue?vue&type=style&index=0&id=a4367526&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4367526"]])

export default __exports__